function toggleFooterMenu() {
  const accordions = document.querySelectorAll(".footer-accordion");

  accordions.forEach(accordion => {
    accordion.addEventListener("click", () => {
      accordion.classList.toggle("active");
      const panel = accordion.nextElementSibling.querySelector(".accordion-panel");
      const plusIcon = accordion.querySelector(".plus-icon-span");
      const minusIcon = accordion.querySelector(".minus-icon-span");

      const isOpen = panel.classList.toggle("show");
      panel.classList.toggle("hide", !isOpen);
      plusIcon.classList.toggle("hide", isOpen);
      minusIcon.classList.toggle("hide", !isOpen);
    });
  });
}

const windowSize = window.matchMedia("(max-width: 1023px)");
if (windowSize.matches) {
  windowSize.addEventListener("change", toggleFooterMenu);
}
toggleFooterMenu();
